module.exports = __webpack_public_path__ + "assets/img/remote.334b04c5.svg";